import {
  DTOHashtagPart,
  DTOMentionPart,
  DTOPlainPart,
  DTORichText,
  DTOUrlPart,
  DTOUrlPartType
} from "~/declarations/graphql/types";

export const RICH_TEXT_TYPENAME: DTORichText["__typename"] = "RichText";
export const RICH_TEXT_PART_PLAIN_PART_TYPENAME: DTOPlainPart["__typename"] =
  "PlainPart";
export const RICH_TEXT_PART_URL_PART_TYPENAME: DTOUrlPart["__typename"] =
  "UrlPart";
export const RICH_TEXT_PART_MENTION_PART_TYPENAME: DTOMentionPart["__typename"] =
  "MentionPart";
export const RICH_TEXT_PART_TAG_PART_TYPENAME: DTOHashtagPart["__typename"] =
  "HashtagPart";

export const RICH_TEXT_PART_TYPENAME = {
  plain: RICH_TEXT_PART_PLAIN_PART_TYPENAME,
  url: RICH_TEXT_PART_URL_PART_TYPENAME,
  mention: RICH_TEXT_PART_MENTION_PART_TYPENAME,
  tag: RICH_TEXT_PART_TAG_PART_TYPENAME
};

export const EXTERNAL_LINK_TYPES = new Set([
  DTOUrlPartType.Email,
  DTOUrlPartType.External
]);

export const INTERNAL_LINK_TYPES = new Set([DTOUrlPartType.Internal]);
